<!-- hour -->
<select class="timeFormControl" (change)="onHourChange(); change.emit()" [(ngModel)]="time.hours" [disabled]="disabled || disableHour" [ngClass]="selectClass">
    <option *ngFor="let hour of hours" [ngValue]="hour.value" [disabled]="hour.disabled"><span [textContent]="hour.value"></span></option>
</select>

<!-- minute -->
<select class="timeFormControl" (change)="onMinuteChange(); change.emit()" [(ngModel)]="time.minutes" [disabled]="disabled || disableMinute" [ngClass]="selectClass">
    <option *ngFor="let minute of minutes" [ngValue]="minute.value" [disabled]="minute.disabled"><span [textContent]="minute.value"></span></option>
</select>

<!-- second -->
<select class="timeFormControl" (change)="change.emit()" [(ngModel)]="time.seconds" [disabled]="disabled || disableHour || disableSecond" [ngClass]="selectClass" *ngIf="!hideSeconds">
    <option *ngFor="let second of seconds" [ngValue]="second.value" [disabled]="second.disabled"><span [textContent]="second.value"></span></option>
</select>

<!-- am/pm -->
<select class="timeFormControl" (change)="change.emit()" [(ngModel)]="time.hourTypes" [disabled]="disabled" *ngIf="!use24HourTime" [ngClass]="selectClass">
    <option *ngFor="let hourType of hourTypes" [ngValue]="hourType"><span [textContent]="hourType"></span></option>
</select>
